<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Selecione o dependente
      <v-chip v-if="atestadoEnviar.dependente > 0 && step > stepConfig" small
        >{{ getDependenteID().nome }} ({{ getDependenteID().grau }})</v-chip
      >
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <v-radio-group
            v-model="atestadoEnviar.dependente"
            v-if="dependentes.length > 0"
          >
            <v-radio
              v-for="(dep, i) in dependentes.filter((dep) => dep.status == 7)"
              :key="i"
              class="pb-2"
              :value="dep.codigo"
            >
              <template v-slot:label>
                {{ dep.nome }} <b class="ml-2">({{ dep.grau }})</b>
              </template>
            </v-radio>
          </v-radio-group>
          <v-alert type="info" max-width="500" text v-else
            >Nenhum dependente encontrado</v-alert
          >
        </v-card-text>
        <v-card-actions>
          <botoes-stepper v-if="dependentes.length > 0" />
          <v-btn
            rounded
            small
            color="secondary"
            text
            @click="setBackStep()"
            v-else
            >Anterior</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import BotoesStepper from "./BotoesStepper.vue";
export default {
  components: { BotoesStepper },
  computed: {
    ...mapState("atestado", ["step", "atestadoEnviar", "atestSelec"]),
    ...mapState("dependentes", ["dependentes"]),
  },
  data: () => ({
    carregando: false,
    stepConfig: 30,
  }),
  methods: {
    ...mapMutations("atestado", ["setBackStep"]),
    getDependenteID() {
      return this.dependentes.find(
        (dep) => dep.codigo == this.atestadoEnviar.dependente
      );
    },
  },
  mounted() {
    if (this.dependentes.length > 0) {
      if (this.atestSelec) {
        this.atestadoEnviar.dependente = this.atestSelec.coddependente;
      } else this.atestadoEnviar.dependente = this.dependentes[0].codigo;
    }
  },
};
</script>

<style>
</style>